import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { UserResponse } from "../../_app/types";
import { setAccounts } from "../../store/slices/userSlice";
import { HubError } from "../../class/Error";
import { showNotification } from "../../store/slices/notificationSlice";
import { motion } from "framer-motion";
import Header from "../../_modules/Header/Header";
import PageLayout from "../../_components/PageLayout";
import AccountCenter from "./components/AccountCenter";
import Loading from "../../_components/Loading";
import { useApi } from "../../_hooks/use-api";
import { ANIM_PROFILE_DURATION, slideAnimationReverse } from "../../_app/animation-consts";
import { useTranslation } from "react-i18next";

const AccountCenterPage = () => {
  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const api = useApi();
  const { t } = useTranslation("profile");

  const getAccounts = async () => {
    try {
      const response: UserResponse = await api.getUserProfile(user.profile.profileId);
      dispatch(setAccounts(response.accounts));
    } catch (error: any) {
      error instanceof HubError
        ? dispatch(
            showNotification({
              message: `${error.message} ${error.detailedMessage}`,
              severity: "error",
            })
          )
        : dispatch(showNotification({ message: error.message, severity: "error" }));
    }
  };

  useEffect(() => {
    getAccounts();
  }, []);

  return (
    <PageLayout
      header={<Header pageTitle={t("accountCenter")} needBack hideAccountsButton />}
      contentSx={{ padding: "20px 8px 0" }}
    >
      <motion.div
        style={{ height: "100%" }}
        initial="in"
        animate="animate"
        exit="out"
        variants={slideAnimationReverse}
        transition={{ duration: ANIM_PROFILE_DURATION }}
      >
        {user.profile.accounts ? <AccountCenter accounts={user.profile.accounts} /> : <Loading />}
      </motion.div>
    </PageLayout>
  );
};

export default AccountCenterPage;
